<template>
  <div class="w-full h-full">
    <!-- mobile bar -->
    <button
      class="lg:hidden fixed z-40 bottom-0 left-0 bg-yellow-brand w-full h-12.5 flex items-center shadow-bar-top print:hidden"
      @click="openSidebar"
    >
      <p
        class="pl-5 font-primary font-extrabold text-14 leading-1 text-center w-full mr-12.5">
        {{ isAddon ? 'Add on: Main Adventure Details' : 'View Available Dates' }}
      </p>
      <div
        class="absolute top-0 right-0 w-12.5 h-12.5 px-3.75 py-4.5 flex flex-col justify-between"
      >
        <div class="h-0.5 w-5 bg-blue-brand rounded-xxs" aria-hidden="true"></div>
        <div class="h-0.5 w-5 bg-blue-brand rounded-xxs" aria-hidden="true"></div>
        <div class="h-0.5 w-5 bg-blue-brand rounded-xxs" aria-hidden="true"></div>
        <span class="sr-only">Open booking details</span>
      </div>
    </button>
    <!-- sidebar -->
    <div
      class="w-full h-full bg-white print:hidden"
      :class="sidebarVisible ? 'fixed z-50 top-0 left-0 overflow-y-scroll' : 'hidden lg:block'"
    >
      <button
        class="lg:hidden fixed z-50 top-0 left-0 bg-grey-light w-full h-12.5 flex items-center shadow-bar-top"
        @click="closeSidebar"
      >
        <p class="pl-5 font-primary font-extrabold text-14 leading-1">Booking Details</p>
        <div
          class="absolute top-0 right-0 w-12.5 h-12.5 px-3.75 py-4.5 flex items-center justify-center"
        >
          <div
            class="absolute transform rotate-45 h-0.5 w-5 bg-blue-brand rounded-xxs"
            aria-hidden="true"
          ></div>
          <div
            class="absolute transform -rotate-45 h-0.5 w-5 bg-blue-brand rounded-xxs"
            aria-hidden="true"
          ></div>
          <span class="sr-only">Close booking details</span>
        </div>
      </button>

      <!-- sidebar content -->
      <div class="pt-12.5 lg:pt-0 print:hidden">
        <div class="lg:border-r border-black-0.1">
          <h2 v-if="isAddon" class="hidden lg:block p-5 title text-32 text-blue-brand">
            Add on for:
          </h2>

          <slot></slot>

          <div class="border-t border-b border-black-0.1 p-5 text-center bg-white">
            <p class="text-20 leading-1.6">Or speak to us now</p>
            <a href="tel:+442078460197"><p class="font-primary font-extrabold text-blue-brand text-28 leading-1 -tracking-1/2">
            {{ phoneNumber }}
          </p></a>
          </div>

          <div class="p-5 pb-0 text-center bg-white" v-if="adventure">
            <share-this-button :title="adventure.name"></share-this-button>
          </div>

          <div class="border-b border-black-0 p-5 pt-0 text-center bg-white">
            <print-button class="mt-4 w-full"></print-button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import ShareThisButton from './ShareThisButton.vue';
export default {
  components: { ShareThisButton },

  props: {
    isAddon: {
      type: Boolean,
      default: false,
    },

    phoneNumber: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      sidebarVisible: false,
      scrollY: null,
    };
  },

  computed: {
    adventure() {
      return this.$store.state.departure.adventure;
    }
  },

  methods: {
    openSidebar: function() {
      this.sidebarVisible = true;
      this.scrollY = window.scrollY;
      document.body.classList.add('fixed', 'left-0', 'right-0');
      document.documentElement.style.overflow = 'scroll';
      document.documentElement.style['-webkit-overflow-scrolling'] = 'touch';
      document.body.style.top = `-${this.scrollY}px`;
    },

    closeSidebar: function() {
      this.sidebarVisible = false;
      document.documentElement.style.overflow = '';
      document.documentElement.style['-webkit-overflow-scrolling'] = '';
      document.body.classList.remove('fixed', 'left-0', 'right-0');
      document.documentElement.style.scrollBehavior = 'auto';
      window.scrollTo({
        top: this.scrollY,
        left: 0,
        behavior: 'auto',
      });
      document.documentElement.style.scrollBehavior = 'smooth';
    },
  },
};
</script>
